import { CategoryStandardProduct } from "shared/api/middleware-api-client";
import { REACT_APP_GERS_API_URL } from "shared/config";
import { concatClassnames } from "shared/utils/concatClassnames";

interface Props {
  className?: string;
  selectedSample: CategoryStandardProduct | undefined;
}
const SampleImage = ({ className, selectedSample }: Props) => {
  return (
    <div className={concatClassnames(className)}>
      <div className="gg-relative gg-aspect-[3/2] gg-w-full gg-bg-gray-50">
        {selectedSample !== undefined ? (
          <img
            src={`${REACT_APP_GERS_API_URL}/StandardProducts/download-file/${selectedSample.imageId}`}
            alt={selectedSample.mainImageAltText}
            className="gg-h-full gg-w-full gg-object-cover gg-object-center"
            loading="eager"
            decoding="async"
          />
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="316"
            height="274"
            viewBox="0 0 316 274"
            fill="none"
            className={concatClassnames("gg-w-full")}
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M172.738 0.498962L173.163 0L173.79 0.190358L203.107 9.09017L203.817 9.30556V10.047V20.8332L214.159 24.124L220.902 16.2044L221.327 15.7055L221.954 15.8958L251.271 24.7956L251.98 25.011V25.7525V36.5387L262.323 39.8295L269.066 31.9099L269.491 31.4109L270.118 31.6013L299.435 40.5011L300.144 40.7165V41.458V52.2548L314.381 57.0003L315.064 57.2282V57.949V67.634V67.9941L314.835 68.2715L145.477 272.967L145.045 273.489L144.4 273.281L4.62036 228.259L4.16034 228.111L3.99063 227.658L0.0642395 217.188L0.000579834 217.018V216.837V203.749V203.381L0.239166 203.1L172.738 0.498962ZM299.48 54.1416L312.366 58.4369L144.115 262.52L131.733 258.242L299.48 54.1416ZM129.721 259.663L129.743 259.67L143.466 264.411L143.664 270.943L5.69357 226.503L2.66162 218.418L33.3994 228.254L33.4157 228.259L48.8431 233.489L48.8513 233.492L48.8594 233.495L81.5631 243.96L81.5793 243.965L97.0069 249.195L97.015 249.197L97.0232 249.2L129.721 259.663ZM35.4116 226.824L203.159 22.7228L212.753 25.7754L48.4028 218.806L48.1642 219.086V219.454V231.147L35.4116 226.824ZM34.7205 224.515L201.817 21.2062V12.8195L34.7205 214.318V224.515ZM33.3785 212.803L201.087 10.5669L173.836 2.29447L2.74295 203.245L33.3785 212.803ZM32.7205 214.693L2.00058 205.108V216.107L32.7205 225.937V214.693ZM145.455 264.037L145.626 269.65L313.064 67.274V60.734L145.455 264.037ZM251.323 38.4282L83.5752 242.53L96.3279 246.853V235.16V234.792L96.5665 234.511L260.917 41.4809L251.323 38.4282ZM249.98 36.9117L82.8841 240.221V230.023L249.98 28.525V36.9117ZM249.25 26.2723L81.5421 228.509L50.9066 218.95L222 17.9999L249.25 26.2723ZM50.1642 220.814L80.8841 230.398V241.643L50.1642 231.812V220.814ZM98.3279 247.518V236.519L129.048 246.104V257.348L98.3279 247.518ZM131.048 255.926L298.144 52.6171V44.2304L131.048 245.729V255.926ZM129.706 244.214L99.0703 234.656L270.164 33.7054L297.414 41.9778L129.706 244.214Z"
              fill="#D4D4DA"
            />
          </svg>
        )}
      </div>
    </div>
  );
};
export default SampleImage;
